import * as React from 'react';
const missingContext = () => {
    // We previously logged an error here but it was extremely noisy and low signal.
    // TODO(mgerstman): Consider how to handle this as we determine a long term solution.
};
export const KeyboardBindingContext = React.createContext({
    registerKeyBindings: missingContext,
    unregisterKeyBindings: missingContext,
});
KeyboardBindingContext.displayName = 'KeyboardBindingContext';
//# sourceMappingURL=context.preenvesnextjs.map
